import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper
} from '@mui/material';
import type { Parcela } from '@azoupvendas/shared';

// AIDEV-NOTE: Helpers de formatacao consistentes com PedidoDetailPage
function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
}

function formatDate(dateStr: string): string {
  // AIDEV-NOTE: dateStr vem no formato YYYY-MM-DD; parse com split para evitar timezone offset
  const [year, month, day] = dateStr.split('-').map(Number) as [number, number, number];
  return new Date(year, month - 1, day).toLocaleDateString('pt-BR');
}

interface ParcelasTableProps {
  parcelas: Parcela[];
}

// AIDEV-NOTE: Tabela MUI reutilizavel de parcelas.
// Exibe resumo "X parcelas de R$ Y,YY" acima da tabela e linha de total no rodape.

export function ParcelasTable({ parcelas }: ParcelasTableProps) {
  if (parcelas.length === 0) return null;

  const total = parcelas.reduce((acc, p) => acc + p.valor, 0);
  const valorPrimeira = parcelas[0]?.valor ?? 0;

  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {parcelas.length} parcela{parcelas.length > 1 ? 's' : ''} de{' '}
        <strong>{formatCurrency(valorPrimeira)}</strong>
      </Typography>

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>N.</TableCell>
              <TableCell>Vencimento</TableCell>
              <TableCell align="right">Valor</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {parcelas.map((p) => (
              <TableRow key={p.numero}>
                <TableCell>{p.numero}</TableCell>
                <TableCell>{formatDate(p.vencimento)}</TableCell>
                <TableCell align="right">{formatCurrency(p.valor)}</TableCell>
              </TableRow>
            ))}
            {/* Linha de total */}
            <TableRow>
              <TableCell colSpan={2}>
                <Typography variant="body2" fontWeight="bold">
                  Total
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="body2" fontWeight="bold" color="primary">
                  {formatCurrency(total)}
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
